import { GridWithGapsNoCols } from '@dreamstack/feature-components'
import { useTranslation } from '@dreamstack/i18n'
import type { FunctionComponent } from 'react'
import tw from 'twin.macro'

const BigGridFont = tw.p`text-px-20 leading-px-30 ml:(text-px-48 leading-px-60) font-semibold`
const SmallGridFont = tw.p`text-px-16 leading-px-24 font-normal mt-px-8 ml:(font-semibold)`
const GridEntry = tw.div``

export const WerGridTable: FunctionComponent<React.PropsWithChildren<{}>> = () => {
  const t = useTranslation()
  return (
    <GridWithGapsNoCols tw="grid-cols-2 mt-px-40 gap-y-px-24 md:(grid-cols-3 mt-px-80 gap-y-px-48) lg:(grid-cols-5 mt-px-64) ">
      <GridEntry>
        <BigGridFont>{t('accentro:werGridTable.years')}</BigGridFont>
        <SmallGridFont>
          {t('accentro:werGridTable.profoundKnowledge')}
        </SmallGridFont>
      </GridEntry>
      <GridEntry>
        <BigGridFont>80</BigGridFont>
        <SmallGridFont>{t('accentro:werGridTable.majorCities')}</SmallGridFont>
      </GridEntry>
      <GridEntry>
        <BigGridFont>85%</BigGridFont>
        <SmallGridFont>
          {t('accentro:werGridTable.ofGermanMarket')}
        </SmallGridFont>
      </GridEntry>
      <GridEntry>
        <BigGridFont>{t('accentro:werGridTable.safe')}</BigGridFont>
        <SmallGridFont>{t('accentro:werGridTable.dataBasedOn')}</SmallGridFont>
      </GridEntry>
      <GridEntry>
        <BigGridFont>{t('accentro:werGridTable.partner')}</BigGridFont>
        <SmallGridFont>
          {t('accentro:werGridTable.ofThe')} &ldquo;Institut der deutschen
          Wirtschaft&rdquo;
        </SmallGridFont>
      </GridEntry>
    </GridWithGapsNoCols>
  )
}
